import React, { useEffect, useState } from "react";
import { MsalAuthenticationTemplate } from "@azure/msal-react"
import { Helmet } from "react-helmet"
import Header from "../../../components/header"
import Navbar from "../../../components/NavBar"
import { InteractionType } from "@azure/msal-browser"
import { loginRequest } from "../../../auth/AuthConfig"
import '../../../styles/dashboardStyles.css';
import DatabasesTable from "../components/DatabasesTable"
import DatabaseEnvironmentDropdown from "../components/DatabaseEnvironmentDropdown"
import { fetchClientDatabases } from "../api/fetchClientDatabasesAPI";
import { callDatabaseCopyAPI } from "../api/callDatabaseCopyAPI";
import { ClientDatabase } from "../types/db_management_types";
import { getDatabaseEnvironmentLabel } from "../utils/db_management_utils";
import DatabaseManagementStatusMessage from "../components/DatabaseManagementStatusMessage";
import "../styles/DbManagementStyles.css";


type DatabasesTableProps = {
  DataList: ClientDatabase[] | null;
  selectedEnv: string;
  handleCopyDatabase: (group?: string) => void;
  onGroupSelected: (group: string) => void;
};

function MainDBManagementPage() {

    const [data, setData] = React.useState<ClientDatabase[] | null>(null);
    const [loading, setLoading] = React.useState<boolean>(true);
    const [error, setError] = React.useState<string | null>(null);
    const [selectedEnv, setSelectedEnv] = useState<string>("");
    const [selectedGroup, setSelectedGroup] = useState<string>("");
    const [showStatus, setShowStatus] = useState<boolean>(false);
    const [statusMessage, setstatusMessage] = useState<string>("");
    const [copyDatabaseGroup, setcopyDatabaseGroup] = useState<string>("");
    const [copyDatabaseENV, setcopyDatabaseENV] = useState<string>("");
    const [isError, setisError] = useState<boolean>(false);

    const handleGroupSelected = (group: string) => {
        setSelectedGroup(() => group);
    };

    const handleCopyDatabase = (group?: string) => {
        if (group) {
            setSelectedGroup(() => group);
        }
        const groupToUse = group ?? selectedGroup;
        const selectedEnvName = getDatabaseEnvironmentLabel(Number(selectedEnv));
        setcopyDatabaseGroup(() => groupToUse);
        setcopyDatabaseENV(() => copyDatabaseENV)
    };

    useEffect(() => {

        if (copyDatabaseGroup === undefined || copyDatabaseGroup === "") return;

        const controller = new AbortController();
        (async () => {
            try {
                setLoading(true);
                setError(null);
                const return_value = await callDatabaseCopyAPI(controller.signal);
                setShowStatus(() => true);
                setisError(() => false)
                setstatusMessage(`Client: ${copyDatabaseGroup} Operation: ${return_value} ` );
            } catch (e: any) {
                setError(e?.message ?? "Failed to call Database Copy API");
                setisError(() => true)
                setShowStatus(() => true);
                setstatusMessage(`Client: ${copyDatabaseGroup} Error: ${e?.message}`);
            } finally {
                setLoading(false);
            }
        })();
        return () => controller.abort();
    }, [copyDatabaseGroup]);

    
    useEffect(() => {
        const controller = new AbortController();
        (async () => {
            try {
                setLoading(true);
                setError(null);
                const rows = await fetchClientDatabases(controller.signal);
                setData(rows)
            } catch (e: any) {
                setError(e?.message ?? "Failed to fetch Client Databases");
            } finally {
                setLoading(false);
            }
        })();
        return () => controller.abort();
    }, []);

    return(
        <>
  
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest} >

            <div className="full-height-form p-fluid">
                <Helmet>
                    <title>DB Management</title>
                </Helmet>
                <Header />
                <Navbar />
                    <h1 className='Ph1'>Database Management</h1>
                    <div className='control-container'>
                        <DatabaseManagementStatusMessage statusMessage={statusMessage} showStatus={showStatus} isError={isError} />
                    <DatabaseEnvironmentDropdown selectedEnv={selectedEnv} onEnvChange={setSelectedEnv} />                    
                    <DatabasesTable DataList={data} selectedEnv={selectedEnv} handleCopyDatabase={handleCopyDatabase} onGroupSelected={handleGroupSelected} />
                    </div>

                </div>

            </MsalAuthenticationTemplate>

        </>
  
    )
}
 
export default MainDBManagementPage;